module.exports = __webpack_public_path__ + "img/error-404.8cc9c22d.svg";